import React, { Dispatch, useMemo } from 'react';
import '../../App.css';
import HotwashNode from './HotwashNode'
import { IInjectInfo, IGameStatus, IHotwash, IInjectNode } from '../../interfaces';
import {isEmpty} from "lodash";

interface TurnProps {
    setInjectItem: Dispatch<any>;
    injectItem: IInjectInfo;
    turn: number;
    currentTurn: number;
    currentGame: IGameStatus;
    hotwashStatus: IHotwash;
    isHost: boolean;
    updateHotwashStatus: Dispatch<any>;
  }

  export interface InjectState {
    hasDropped: boolean
    hasDroppedOnChild: boolean;
  }

  const HotwashNodeTurn: React.FC<TurnProps> = ({ turn, setInjectItem, injectItem, currentTurn, currentGame, hotwashStatus, isHost, updateHotwashStatus }) => {

      const played: Map<string, string> = useMemo(() => {
          let played: Map<string, string> = new Map<string, string>() //{ '1': true };
          played.set("1", "")
          let currentMove = "1"
          const moveHistory = injectItem.moveHistory.filter((m) => m.injectId === injectItem.injectId && m.type === 'result' && m.options.choiceType === 'coa');
          let moveMap = moveHistory.reduce((play: Map<string, string>, move) => {
              const coaChoice = parseInt(move.choice, 10);
              let node = injectItem.nodes.find((n) => n.id === currentMove);
              if(node === undefined) return play;
              let coa = node.coas.find((c) => c.id === coaChoice);
              while (!coa) {
                  if(node.timeToLive !== null && !isEmpty(node.timeToLive.nextNodeId)) {
                      played.set(currentMove, node.timeToLive.nextNodeId)
                      played.set(node.timeToLive.nextNodeId, "")
                      currentMove = node.timeToLive.nextNodeId;
                  }
                  else {
                      return play;
                  }
                  let nodeIdToFind = currentMove
                  node = injectItem.nodes.find((n) => n.id === nodeIdToFind);
                  if(node === undefined) return play;
                  coa = node.coas.find((c) => c.id === coaChoice);
              }
              if(play.has(currentMove)) {
                  play.set(currentMove, coa.nextNodeId);
              }
              play.set(coa.nextNodeId, "");
              currentMove = coa.nextNodeId;
              return play;
          }, played)
          let injectNodeId = "1"
          let done = false
          while(!done) {
              let nextNode = played.get(injectNodeId)
              if(nextNode !== undefined && !isEmpty(nextNode)) {
                  injectNodeId = nextNode
              }
              else {
                  let nodeToFindId = injectNodeId // prevents warning about unsafe references in find function
                  let node = injectItem.nodes.find((n) => n.id === nodeToFindId)
                  if(node !== undefined && node.timeToLive !== null && !isEmpty(node.timeToLive.nextNodeId)) {
                      played.set(injectNodeId, node.timeToLive.nextNodeId)
                      played.set(node.timeToLive.nextNodeId, "")
                  }
                  else{
                      done = true
                  }
              }
          }

          return moveMap;
      }, [injectItem]);

      /*const hotwashTurns:Map<number, IInjectNode[]> = useMemo(() => {
          let turns = new Map<number, IInjectNode[]>();
          injectItem.nodes.forEach((node) => {
              if(!turns.has(node.turn)) {
                  turns.set(node.turn, []);
              }
              turns.get(node.turn)?.push(node);
          });
          return turns;
      }, [injectItem.nodes]);*/

    return (
        <>
        { hotwashStatus.currentSelection ? turn === hotwashStatus.currentSelection.nodeTurn ? <div className={`turn turn${turn} hotwash-current-turn-lane`}>
        <div className="hotwash-turn-label node-current-turn">Turn {turn} <span>Current</span></div>
            { injectItem.nodes.map((item: IInjectNode, i: number) => {
              
              if (item.turn === turn) {
                return (
                    <div key={i}>
                          <HotwashNode played={played.has(item.id)} injectItem={injectItem} turn={turn} id={item.id} key={item.id} index={i} currentGame={currentGame} currentTurn={currentTurn} hotwashStatus={hotwashStatus} isHost={isHost} updateHotwashStatus={updateHotwashStatus} />
                    </div>
                )
              } else {
                return <div key={i}></div>
              }
            })}
        </div> : <div className={`turn turn${turn}`}>
        <div className="hotwash-turn-label">Turn {turn}</div>
            { injectItem.nodes.map((item: any, i: number) => {
              
              if (item.turn === turn) {
                return (
                    <div key={i}>
                          <HotwashNode played={played.has(item.id)} injectItem={injectItem} turn={turn} id={item.id} key={item.id} index={i} currentGame={currentGame} currentTurn={currentTurn} hotwashStatus={hotwashStatus} isHost={isHost} updateHotwashStatus={updateHotwashStatus} />
                    </div>
                )
              } else {
                return <div key={i}></div>
              }
            })}
        </div> : <></> }
        </>
    )
}

export default HotwashNodeTurn;